import ApiClient from './apiClient';
import UserService from './controllers/user/UserService';
import AuthService from './controllers/auth/AuthServices';
import FormulaService from './controllers/formula/FormulaService';
import WarehouseService from './controllers/warehouse/WarehouseService';

export class ApiService {
  public user: UserService;

  public auth: AuthService;

  public formula: FormulaService;

  public warehouse: WarehouseService;

  constructor() {
    this.user = new UserService(ApiClient);
    this.auth = new AuthService(ApiClient);
    this.formula = new FormulaService(ApiClient);
    this.warehouse = new WarehouseService(ApiClient);
  }
}

const api = new ApiService();

export default api;
